import { render } from "./featuresItem2.vue?vue&type=template&id=30e42e85"
import script from "./featuresItem2.vue?vue&type=script&lang=js"
export * from "./featuresItem2.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__